import script from "./ListTmp.vue?vue&type=script&setup=true&lang=js"
export * from "./ListTmp.vue?vue&type=script&setup=true&lang=js"

import "./ListTmp.vue?vue&type=style&index=0&id=c71a9700&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c71a9700"]])

export default __exports__